import React from 'react';
import '../../../Styles/Layout/Buttons.css';
import { SendIcon } from '../../../assets/CustomSvgs';
import { useAuth } from '../../../contexts/AuthContext';
import { useAttachmentContext } from '../../../contexts/AttachmentContext';
import { HoverToolTip } from '../Items/HoverToolTip';
import { StopButton } from './StopButton';

interface SubmitButtonProps {
  isSubmitting: boolean;
  input: string;
  isFileProcessing: boolean;
  onStopStreaming: () => void;
  isStreaming: boolean;
}

export const SubmitButton: React.FC<SubmitButtonProps> = ({
  isSubmitting,
  input,
  isFileProcessing,
  onStopStreaming,
  isStreaming,
}) => {
  const { textFiles, imageFiles } = useAttachmentContext();
  const auth = useAuth();
  const remainingChats = auth.chatUsageData?.remaining;

  const isDisabled =
    auth.isLoading ||
    (!input?.trim() && !textFiles?.length && !imageFiles?.length) ||
    (remainingChats !== null && remainingChats !== undefined && remainingChats <= 0) ||
    isFileProcessing || isSubmitting;

  const getSendTooltipText = () => {
    if (isSubmitting) return 'Sending Message';
    if (!input?.trim()) return 'Enter a message';
    if (remainingChats !== null && remainingChats !== undefined && remainingChats <= 0)
      return 'No chats left';
    if (isFileProcessing) return 'Processing File';
    return 'Send Message';
  };

  if (isStreaming && auth.user) {
    return <StopButton onStopStreaming={onStopStreaming} />;
  }

  return (
    <button type="submit" disabled={isDisabled} className="submit-button">
      <SendIcon disabled={isDisabled} />
      <HoverToolTip text={getSendTooltipText()} position="top" />
    </button>
  );
};
